var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 9.58335C11.6414 9.06729 10.9888 9.06729 10.4694 9.58335C10.0732 9.97622 9.67699 10.3691 9.28744 10.7686C9.1809 10.8785 9.091 10.9018 8.96115 10.8286C8.70479 10.6887 8.43177 10.5755 8.18539 10.4224C7.03673 9.69988 6.07452 8.77097 5.22218 7.72552C4.79934 7.20612 4.42311 6.65011 4.16009 6.02417C4.10682 5.89765 4.11681 5.81441 4.22002 5.7112C4.61622 5.32832 5.00244 4.93544 5.39198 4.54257C5.93468 3.99654 5.93468 3.35728 5.38866 2.80792C5.07902 2.49495 4.76938 2.18864 4.45974 1.87568C4.14011 1.55605 3.82381 1.23309 3.50086 0.916795C2.97813 0.40739 2.32556 0.40739 1.80617 0.920125C1.40663 1.313 1.02375 1.71586 0.617555 2.10208C0.241327 2.45833 0.0515486 2.89449 0.0115952 3.40389C-0.0516643 4.23293 0.151432 5.01535 0.437765 5.77779C1.02375 7.35595 1.91604 8.75765 2.99811 10.0428C4.45974 11.7808 6.20437 13.1558 8.24532 14.148C9.16425 14.5942 10.1165 14.9371 11.1519 14.9937C11.8644 15.0337 12.4837 14.8539 12.9798 14.2978C13.3194 13.9183 13.7023 13.572 14.0619 13.2091C14.5946 12.6697 14.5979 12.0172 14.0685 11.4845C13.4359 10.8485 12.8 10.2159 12.1641 9.58335Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c2062765.svg";
export { ForwardRef as ReactComponent };